import { render, staticRenderFns } from "./YButton.vue?vue&type=template&id=5df8ef7b&scoped=true&"
import script from "./YButton.vue?vue&type=script&lang=js&"
export * from "./YButton.vue?vue&type=script&lang=js&"
import style0 from "./YButton.vue?vue&type=style&index=0&id=5df8ef7b&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df8ef7b",
  null
  
)

export default component.exports